export default "__VITE_ASSET__CG$iKjMf__"